import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {Subject} from 'rxjs/Subject';
import {AngularFirestore} from 'angularfire2/firestore';


@Injectable()

export class FirebaseUserService {

  constructor(private afs: AngularFirestore) {

  }

  /**
   * Get User Object from Firebase DB
   * @param uid
   * @returns {Observable<UserDB>}
   */
  getUserByUID(uid): Observable<any> {
    return this.afs.collection('users').doc(uid).valueChanges();
  }


  updateUserByUID(uid, formValue) {
    const userRef = this.afs.collection('users').doc(uid);
    const trans = userRef.update({
      firstName: formValue.firstName,
      lastName: formValue.lasstName,
      phone: formValue.phone,
      email: formValue.email,
    });

    return this.fromFirebaseAuthPromise(trans);
  }


  // Convert Promise of Firebase to an Observable
  fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/firebase/user.service.ts